import React from 'react';
import ExclamationFilledIcon from '@shared/assets/icons/v2/exclamation-filled.svg';
import { View } from '@shared/components/View';
import classNames from './WarningSubfooter.module.css';

interface WarningSubfooterProps {
  message: string;
  showWarning: boolean;
}

export function WarningSubfooter({ showWarning, message }: WarningSubfooterProps) {
  if (!showWarning) {
    return null;
  }
  return (
    <View row className={classNames.warningSubfooter}>
      <View className={classNames.warningPill}>
        <View className={classNames.icon}>
          <ExclamationFilledIcon />
        </View>
        {message}
      </View>
    </View>
  );
}
